import React from "react";
import fish from "../img/fish.jpg";
function Fish() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="aqua"
    >
      <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={fish}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div>
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <p className="text-[2rem] lg:text-[2rem] font-bold tracking-wide text-slate-700">
        FISHES AQUARIUM FISHES 
        </p>
        <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
         Molly Temperature: Mollies are a tropical
          fish that needs temperatures in the range of 75°-80°F (24°-26.7°C). A
          heater is an absolute necessity that will keep the water warm and hold
          it at a steady temperature. PH Value: Mollies require a stable living
          space and hard water from 15 to 30 dGH. Every type of molly prefers a
          unique water pH. But, in general, the perfect molly pH Level can range
          from 7.5 – 8.5 and provide the fish with an adequate environment to
          live in. About: Mollies do not lay eggs like other fish breeds.
          Instead, they give birth to live fish. Male mollies fertilize the eggs
          when they are in the female's belly. The female molly can store sperm
          and continue giving birth without having to mate. Mollies reproduce
          several times a year. In fact, they are amongst the easiest fish
          species to breed Male Mollies can become reproductive at the age when
          they are about 12 months old while female molly fish usually becomes
          reproductive in half of the age of male mollies, which means they can
          become reproductive at the age of about 6 months. 2. Goldfish About:
          Goldfish mate by chasing each other until the female goldfish releases
          her eggs. The male goldfish then releases his “milt”, which fertilizes
          the eggs. Get the best from The Goldfish Tank delivered straight to
          your inbox. Assuming the eggs don't get eaten, baby goldfish will
          hatch around a week later. The breeding season for the goldfish is in
          the late spring and early summer. Goldfish reach their sexual maturity
          between their first or second year, but it isn't until age 6 or 7
          before they start to reproduce. In the wild, female goldfish lay their
          eggs around proffered fixed objects, substrate vegetation or immersed
          tree roots. Temp: A tank water temperature of between 20°C – 23°C (68
          °F – 74°F) is an ideal temperature for goldfish. This temperature will
          be high enough to encourage strong growth, but without being so high
          that your fish become stressed by hot water and low oxygen levels.
          Stability is also very important PH: While Goldfish will adjust to
          many pH levels, they do best at a pH of 6.5 - 7.5. If your pH is far
          off from this level, your Goldfish may show signs of a loss of
          appetite, sluggishness, and poor health. 3. Red tail shark Ph temp: In
          home aquaria, redtail sharks prefer a pH between 6.8 and 7.5, a
          temperature between 22 °C and 26 °C (72 °F and 79 °F) and water
          hardness between 5 and 15 dH. About: Not much is known about red tail
          sharks breeding habits, and it is extremely rare to have them breed in
          a home aquarium. Commercial facilities breed them by introducing
          hormones into their ponds, which is something that can't easily be
          replicated in a home aquarium. are difficult to breed in captivity but
          it can be done with the right equipment and preparation Since the
          red-tailed shark reproduces with eggs, it is physically impossible for
          a red-tailed shark to actually become pregnant. However, female
          red-tailed sharks may swell up with eggs when breeding, though this is
          very rare in the home aquarium. 4. Arowana About: Breeding arowanas in
          an aquarium is virtually impossible and most arowana are bred in large
          fish farms in Asia. Unlike most fish, the Asian arowana reaches sexual
          maturity relatively late, after 3–4 yr. The females produce few eggs,
          30-100, which are quite large. After the eggs are fertilized, the
          Asian arowana exhibits great parental care with paternal
          mouthbrooding. PH: The original habitat of Arowana is in the rain
          forests, where the pH level is around 5.5 to 7 and the water is
          slightly acidic. Slightly acidic water is one of the critical factors
          of Arowana's bright colors, especially Red Arowana. Temp: In terms of
          temperature: Arowanas are tropical fish, so they should be kept in
          water around 30° Celsius (or 86° Fahrenheit). NORMAL FOND FISHES Carp
          Carp is a fleshy freshwater fish that is originally attributed to
          Europe and Asia. This river fish is well adapted to the biofloc fish
          farming setup and is an omnivorous species, well-adjusted to a
          plethora of feed options. TEMP: The best growth is obtained in this
          variety when the water temperature is maintained 23 °C and 30 °C.
          These fish can stand cold winter periods and salinity up to 5%. PH:
          The optimal pH range that is required for this fish to thrive is
          anywhere between 6.5-9.0. These fish are known to be robust and can
          survive low oxygen concentration (0.3-0.5 mg/liter) as well as
          supersaturation. 2. koi Ph and temp: It is a scientific fact that
          whilst a pH of 7 - 7.5 is advocated as "ideal" for keeping Koi, Koi
          will live comfortably in a pH range of 6.5 - 8.5. A temperature range
          of 22°C - 28°C is ideal for keeping Koi About: When koi prepare to
          spawn, the males begin chasing after the females, nudging their sides
          with their mouth and fins. This encourages the female koi to lay her
          eggs. Once eggs have been laid, the male koi will fertilize them, and
          the future koi will begin to grow and develop. Koi don't sexually
          mature until they are about 3 years old. Wait until they are 3 years
          old to increase their likelihood of breeding and producing quality
          offspring. Koi are about 10 inches (25 cm) long when they are 3 years
          old. 3. Gourami About: The water level in the breeding tank should be
          six inches deep for breeding most gourami’s. For larger species of
          gourami’s, it may need to be slightly deeper. Ph and temp: Gouramis
          have undergone substantial taxonomic revisions, but this species has
          been known by its current name for a long time. Preferred Water
          Chemistry: Tropical fresh water. Temperature 22 to 28 degrees Celsius
          (72 to 83 degrees Fahrenheit), pH 6.0 to 8.0, hardness 70 to 250 ppm.
        </p>
      </div>
    </section>
  );
}

export default Fish;
